module.exports = __webpack_public_path__ + "static/media/26.f350c8c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/pants/26.png
// module id = 879
// module chunks = 0